export default "__VITE_ASSET__C0l95fmO__"